import type { StreamHandlers } from 'v2/utils/sse-stream'
import { baseService } from './base-services'

export type ChatPlaygroundState = 'ai' | 'preset_wait' | 'human' | 'terminal' | 'waiting'

// The runner's chat bootstrap envelope; preset-turn and state answer with the same shape.
export interface RChatPlaygroundEnvelope {
  session_id: string
  bootstrap_state: ChatPlaygroundState
  pre_ai_messages?: unknown[]
  end_message?: string | null
}

export interface ChatPlaygroundTurnBody {
  message?: string
  message_id?: string
  attachments?: object[]
  trigger?: boolean
}

const sessionPath = (sessionId: string) => encodeURIComponent(sessionId)

// Builder Test agent on the chat pipeline. The runner routes ride hodor's playground-stream
// proxy and the turn rides hodor's chat-playground proxy to agent-runner, both on the console login.
export const chatPlaygroundService = {
  bootstrap: (body: { phlo_id: string; message: string; message_id: string }) =>
    baseService.post<RChatPlaygroundEnvelope>('/v1/playground-stream/chat/bootstrap', body),

  presetTurn: (sessionId: string, body: ChatPlaygroundTurnBody) =>
    baseService.post<RChatPlaygroundEnvelope>(
      `/v1/playground-stream/chat/session/${sessionPath(sessionId)}/preset-turn`,
      body,
    ),

  state: (sessionId: string) =>
    baseService.get<RChatPlaygroundEnvelope>(
      `/v1/playground-stream/chat/session/${sessionPath(sessionId)}/state`,
    ),

  turn: (sessionId: string, body: ChatPlaygroundTurnBody, handlers: StreamHandlers<unknown>) =>
    baseService.stream(
      `/v1/chat-playground/session/${sessionPath(sessionId)}/turn`,
      body,
      handlers,
    ),
}
